export default function PainPointsSection() {
  const painPoints = [
    {
      icon: 'ri-money-dollar-circle-line',
      question: 'High water bill?',
      detail: 'A hidden leak can waste thousands of gallons a month — costing you hundreds.',
    },
    {
      icon: 'ri-water-flash-line',
      question: 'Water leak you can\'t find?',
      detail: 'Behind walls, under slabs, inside pipes — we locate it fast with professional equipment.',
    },
    {
      icon: 'ri-home-heart-line',
      question: 'Worried about water damage?',
      detail: 'Every hour counts. Water damage spreads quickly and gets far more expensive to fix.',
    },
  ];

  return (
    <section className="bg-[#0f1f3d] py-10 sm:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-5 sm:mb-6">
          {painPoints.map((item, index) => (
            <div
              key={index}
              className="bg-white/5 border border-white/10 rounded-xl p-5 sm:p-6 flex items-start gap-4 hover:bg-white/10 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-cyan-500 rounded-lg flex-shrink-0">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <div>
                <h3 className="text-white font-black text-lg sm:text-xl mb-1">{item.question}</h3>
                <p className="text-blue-200 text-sm leading-relaxed">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Callout line */}
        <p className="text-center text-red-300 font-bold text-base sm:text-lg mb-6 sm:mb-8">
          If you&apos;re noticing any of these — call now before it gets worse.
        </p>

        {/* Urgency CTA Banner — navy with red accent border */}
        <div className="bg-[#162447] border-2 border-red-500/60 rounded-2xl px-6 sm:px-10 py-6 sm:py-7 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="text-center sm:text-left">
            <p className="text-white font-black text-xl sm:text-2xl leading-tight mb-1">
              Don&apos;t wait — leaks get worse fast.
            </p>
            <p className="text-blue-200 text-sm sm:text-base font-medium">
              Call now to stop the damage before it costs you more.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="tel:7252675482"
              className="bg-red-600 text-white font-black text-lg sm:text-xl px-8 py-4 rounded-lg hover:bg-red-500 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-phone-fill text-xl"></i>
              Call Now
            </a>
            <a
              href="#contact"
              className="bg-transparent border-2 border-white/40 text-white font-bold text-base sm:text-lg px-6 py-4 rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              Get Free Estimate
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
